"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeConsultaOfertaExtendida = void 0;

var normalizeConsultaOfertaExtendida = function normalizeConsultaOfertaExtendida(data) {
  var normalizedData = {}; // eslint-disable-next-line max-len

  var dataFindNodo5 = data && data.nodos0[0].nodos1[0].nodos2[0].nodos3[0].nodos4[0].nodos5;
  var dataFind = data && data.nodos0[0].nodos1[0].nodos2[0].nodos3[0].nodos4[0].nodos5[0].nodos6[0].nodos7[0].nodos8[0].nodos9[0];

  if (dataFindNodo5.length >= 1) {
    dataFindNodo5.forEach(function (nodo5) {
      if (nodo5.codContrato === 'FFF') {
        dataFind = nodo5.nodos6[0].nodos7[0].nodos8[0].nodos9[0];
      }
    });
  }

  if (dataFind) {
    normalizedData.codContratacion = dataFind.codContratacion;
    normalizedData.codServicio = dataFind.codServ;
  }

  return normalizedData;
};

exports.normalizeConsultaOfertaExtendida = normalizeConsultaOfertaExtendida;

//# sourceMappingURL=productNormalizer.js.map